import { NavLink } from 'react-router';
import { IconApple, IconGoogle, IconKakao, IconNaver } from '@/assets/svgs';
import { Button } from '@/shared/ui';

type SocialLoginButtonsProps = {
	onGoogleLogin: () => void;
	onKakaoLogin: () => void;
	onNaverLogin: () => void;
};

const socialButtonShadow =
	'shadow-[0_4px_16px_rgba(0,0,0,0.08)] hover:shadow-[0_6px_20px_rgba(0,0,0,0.12)]';

const SocialLoginButtons = ({
	onGoogleLogin,
	onKakaoLogin,
	onNaverLogin,
}: SocialLoginButtonsProps) => {
	return (
		<div className="flex shrink-0 flex-col items-center gap-4 self-stretch px-5 pb-[max(24px,6vh)]">
			<Button
				className={`gap-2 bg-black font-medium text-white ${socialButtonShadow}`}
			>
				<IconApple />
				애플로 시작하기
			</Button>
			<Button
				onClick={onGoogleLogin}
				className={`gap-2 border border-mantang-gray-200 bg-white font-medium text-black ${socialButtonShadow}`}
			>
				<IconGoogle />
				구글로 시작하기
			</Button>
			<Button
				onClick={onKakaoLogin}
				className={`gap-2 bg-kakao font-medium text-black ${socialButtonShadow}`}
			>
				<IconKakao />
				카카오로 시작하기
			</Button>
			<Button
				onClick={onNaverLogin}
				className={`gap-2 bg-[#03C75A] font-medium text-white ${socialButtonShadow}`}
			>
				<IconNaver />
				네이버로 시작하기
			</Button>
			<NavLink
				to="/"
				className="cursor-pointer py-1 text-mantang-gray-500 text-xs"
			>
				로그인하지 않고 둘러보기
			</NavLink>
		</div>
	);
};

export default SocialLoginButtons;
